module.exports = __webpack_public_path__ + "static/media/logo-symbol-text-codepen.0d199234.png";